import { useState, useRef, useEffect } from 'react'
import {
    GoogleMap,
    Marker,
    useJsApiLoader,
    Autocomplete
} from '@react-google-maps/api';

import useEnv from './useEnv';

// Move libraries array outside the hook to avoid recreating it on every render
const GOOGLE_MAP_LIBRARIES = ['places'];

function useMapLocation() {

    const [country, setCountry] = useState("Sri Lanka");
    const [address, setAddress] = useState("");
    const [latLng, setLatLng] = useState(null);
    const [error, setError] = useState("");
    const autocompleteRef = useRef(null);

    const apiKey = useEnv('GOOGLE_MAP_API_KEY');

    //Get current location
    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    }

    //Get current postion using open street map
    function showPosition(position) {

        fetch("https://nominatim.openstreetmap.org/reverse?lat=" + position.coords.latitude + "&lon=" + position.coords.longitude + "&format=json")
            .then(res => res.json())
            .then(data => {
                console.log("Country:", data.address.country);
                console.log("Country Code:", data.address.country_code);
                setCountry(data.address.country);
                sessionStorage.setItem("country", data.address.country)
            }).catch(error => console.log(error));


    }

    //if place change event
    const onPlaceChanged = () => {
        const place = autocompleteRef.current.getPlace();
        if (place && place.formatted_address) {
            setAddress(place.formatted_address);
            sessionStorage.setItem("address", place.formatted_address)
            if (place.geometry) {
                const location = place.geometry.location;
                setLatLng({
                    lat: location.lat(),
                    lng: location.lng(),
                });

                sessionStorage.setItem("LatLng", JSON.stringify({
                    lat: location.lat(),
                    lng: location.lng(),
                }))

                // Extract country from address_components
                if (place.address_components) {
                    const countryComponent = place.address_components.find(component =>
                        component.types.includes("country")
                    );
                    if (countryComponent) {
                        setCountry(countryComponent.long_name);
                        sessionStorage.setItem("country", countryComponent.long_name);
                    }
                }

                setError('');
            } else {
                setError('No geometry available for selected place.');
            }
        }
    };

    // Geocode manually entered address
    function geocodeAddress(addressToGeocode) {
        if (window.google && window.google.maps) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: addressToGeocode }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setAddress(results[0].formatted_address);
                    setLatLng({
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng(),
                    });
                    // Extract country
                    const countryComponent = results[0].address_components.find(component =>
                        component.types.includes("country")
                    );
                    if (countryComponent) {
                        setCountry(countryComponent.long_name);
                        sessionStorage.setItem("country", countryComponent.long_name);
                    }
                }
            });
        }
    }


    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: apiKey,
        libraries: GOOGLE_MAP_LIBRARIES,
    });


    return {
        isLoaded,
        country,
        latLng,
        address,
        getLocation,
        setAddress,
        setLatLng,
        onPlaceChanged,
        error,
        apiKey,
        autocompleteRef,
        geocodeAddress
    }
}

export default useMapLocation;